<template>
    <div v-if="icons">
        <marker-button v-for="icon in icons" :key="icon.id" :marker="icon" />
    </div>
    <div v-else>
        <slot/>
    </div>
</template>

<script>

    import MarkerButton from '../ui/MarkerButton.vue'

    export default {
        components: {MarkerButton },
        data() {
            return {
                icons: null,
            }
        },
        props: ['event', 'path'],
        mounted () {
            if (!this.path || !this.event) return;
            Echo.private(`markups.${savedMarkup.uuid}`)
                .listen(this.event, () => {

                    axios.get(this.path)
                        .then(response => {
                            this.icons = response.data.data;
                        })
                        .catch(error => {
                            console.error(error);
                        })
                })

        },
    }
</script>

<style lang="scss" scoped>

</style>
